import styled from 'styled-components';
const ThumbnailButton = styled.button.withConfig({
  displayName: "ThumbnailButton"
})(["background:none;border:none;padding:0;cursor:pointer;display:block;width:100%;"]);
ThumbnailButton.displayName = 'ThumbnailButton';
export default ThumbnailButton;